import ChevronRight from "@mui/icons-material/ChevronRight";
import Folder from "@mui/icons-material/Folder";
import { Drawer, Popover } from "@mui/material";
import { useLocation } from "react-router";
import { ChevronDown } from "../../../../styles/icons/chevron-down";
import { usePopover } from "../../../../utils/hooks/use-popover";
import { usePrograms2026 } from "../../../program-tree/hooks/use-programs-2026";
import { useSidebarWidth } from "../../hooks/use-sidebar-2026";
import { Item } from "./item";
import { ProgramsSelector } from "./programs-selector";

import type { FC } from "react";

export const Programs: FC = () => {
  const [anchorRef, popover] = usePopover<HTMLButtonElement>();
  const { pathname } = useLocation();
  const sidebarWidth = useSidebarWidth();
  const programs2026 = usePrograms2026();

  // The program tree page has its own switcher, so the item only opens the page.
  if (programs2026.enabled) {
    return (
      <Item
        title="Programs"
        icon={<Folder />}
        onClick={{ type: "href", value: "/tabbed-programs" }}
        active={() => pathname.startsWith("/tabbed-programs")}
      />
    );
  }

  return (
    <>
      <Item
        title="Programs"
        icon={<Folder />}
        onClick={{
          type: "function",
          value: popover.handleToggle,
          ref: anchorRef,
        }}
        open={popover.open}
        endIcon={popover.open ? <ChevronDown /> : <ChevronRight />}
        active={() => pathname.startsWith("/tabbed-programs")}
      />
      {popover.open && (
        <Popover
          // oxlint-disable-next-line react/refs -- MUI anchorEl needs the DOM node; the popover only opens after the anchor has mounted
          anchorEl={anchorRef.current}
          open={popover.open}
          onClose={popover.handleClose}
          sx={{
            flexShrink: 0,
            "& .MuiPopover-paper": {
              top: "-100px !important",
            },
          }}
        >
          <Drawer
            sx={{
              flexShrink: 0,
              ml: "147px",
              "& .MuiDrawer-paper": {
                width: 280,
                // Opens beside the sidebar, whichever is showing.
                ml: `${sidebarWidth}px`,
                boxSizing: "border-box",
                backgroundColor: "background.drawer",
              },
            }}
            variant="persistent"
            anchor="left"
            open={popover.open}
          >
            <ProgramsSelector onSelect={popover.handleClose} />
          </Drawer>
        </Popover>
      )}
    </>
  );
};
